/**
 * TutorialPausedPill — what shows when the user walks away mid-tutorial.
 *
 * Navigating off the step's page (browser back, a link, the editor's Exit) stops
 * the tutorial dimming a page it knows nothing about. It does not end it: the
 * work so far is real, so the offer to go back stands until the user declines.
 */

import React from 'react';
import styles from './TutorialPausedPill.module.css';

const TutorialPausedPill = ({ onResume, onExit }) => (
    <div className={styles.pill} data-tutorial-ui="paused" role="status">
        <span className={styles.label}>Tutorial paused</span>
        <button type="button" className={styles.action} onClick={onResume}>
            Resume
        </button>
        <button type="button" className={styles.action} onClick={onExit}>
            Exit
        </button>
    </div>
);

export default TutorialPausedPill;
